import VChart from 'vue-echarts';
import { use, registerMap } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { MapChart } from 'echarts/charts';
import { LegendComponent, TooltipComponent } from 'echarts/components';
import chinaMap from './china.json';

use([MapChart, CanvasRenderer, LegendComponent, TooltipComponent]);

registerMap('china', chinaMap);

export default {
    name: 'componentsLine',

    props: {
        chartData: {
            type: Object,
        },
        legendshow: {
            type: Boolean,
            default: false,
        },
        flag: {
            type: Boolean,
        },
    },
    watch: {
        flag() {
            this.date();
            this.$refs.map.setOption(this.option);
        },
    },
    components: {
        VChart,
    },

    data() {
        return {
            option: {
                geo: {
                    map: 'china',
                    zoom: 1,
                    roam: false,
                    // roam: true,
                    itemStyle: {
                        opacity: 0.7,
                        areaColor: '#5cbd38',
                        borderWidth: 3,
                        borderColor: '#5cbd38',
                        shadowColor: '#5cbd38',
                        shadowBlur: 8,
                    },
                },
                tooltip: {
                    show: false,
                },
                series: [{
                        type: 'map',
                        mapType: 'china',
                        itemStyle: {
                            areaColor: '#16181f',
                            borderWidth: 1,
                            borderColor: '#31343f',
                        },
                        silent: true,
                        tooltip: {
                            show: false,
                        },
                    },
                    {
                        data: [],
                        name: '线条',
                        type: 'lines',
                        tooltip: {
                            show: false,
                        },
                        lineStyle: {
                            color: {
                                type: 'linear',
                                colorStops: [{
                                        offset: 0,
                                        color: 'rgba(121, 255, 64, 0)',
                                    },
                                    {
                                        offset: 1,
                                        color: '#79ff40',
                                    },
                                ],
                            },
                            width: 2,
                            opacity: 1,
                            curveness: 0.2,
                        },
                    },
                ],
            },
        };
    },

    created() {
        this.date();
    },
    methods: {
        upDate(date) {
            const { option } = this;
            option.series[4].data = date;
            this.option = option;
            this.$refs.map.setOption(this.option);
        },
        date() {
            if (this.legendshow) {
                this.option.legend = [];
            }
            const { option, chartData } = this;
            const { lines, tooltip, garden, grass, cow, horse, sheep } = chartData;
            const effectScatter = {
                type: 'effectScatter',
                symbolKeepAspect: true,
                symbolSize: [15, 15],
                coordinateSystem: 'geo'
            };
            option.series[1].data = lines;
            option.series[1].tooltip = tooltip,
            option.series[2] = {
                ...effectScatter,
                name: '园区分布',
                data: garden.filter(item => { return item.show }),
                symbol: 'image://https://nfs.nxin.com/cms_image_859135d1-3a71-41c6-b49a-dd707a4a4cb9.png',
                tooltip: {
                    show: true,
                    formatter: (param) => {
                        return `园区：${param.data.name}`
                    },
                    shadowBlur: 10,
                    borderColor: 'rgba(0,0,0,0.5)',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    textStyle: {
                        color: '#fff',
                    },
                },
            };
            option.series[3] = {
                ...effectScatter,
                name: '草数据',
                data: grass.filter(item => { return item.show }),
                symbol: 'image://https://nfs.nxin.com/cms_image_cac7a52c-c18c-49ab-9f27-2a00002863d3.png',
                tooltip: {
                    show: true,
                    formatter: (param) => {
                        return `位置：${param.data.name}`
                    },
                    // <br /> 描述：站位
                    shadowBlur: 10,
                    borderColor: 'rgba(0,0,0,0.5)',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    textStyle: {
                        color: '#fff',
                    },
                },
            };
            option.series[4] = {
                ...effectScatter,
                name: '牛数据',
                data: cow.filter(item => { return item.show }),
                symbol: 'image://https://nfs.nxin.com/cms_image_edd6ff90-7722-4235-84b8-adbeaa48d5c8.png',
                tooltip: {
                    show: true,
                    formatter: (param) => {
                        return `位置：${param.data.name}`
                    },
                    shadowBlur: 10,
                    borderColor: 'rgba(0,0,0,0.5)',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    textStyle: {
                        color: '#fff',
                    },
                },
            };
            option.series[5] = {
                ...effectScatter,
                name: '马数据',
                data: horse.filter(item => { return item.show }),
                symbol: 'image://https://nfs.nxin.com/cms_image_70c271ea-bedb-4be1-a334-a093e29bd814.png',
            };
            option.series[6] = {
                ...effectScatter,
                name: '羊数据',
                data: sheep.filter(item => { return item.show }),
                symbol: 'image://https://nfs.nxin.com/cms_image_4dd293cc-f816-4f5e-b497-7c4ba924bec8.png',
            };
        },
    },
};
